import { render } from "./highlighted-feature.vue?vue&type=template&id=55e3940c&ts=true"
import script from "./highlighted-feature.ts?vue&type=script&lang=ts&external"
export * from "./highlighted-feature.ts?vue&type=script&lang=ts&external"

import "./highlighted-feature.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__